import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import qhistory from 'qhistory'
import { createBrowserHistory } from 'history'
import qs from 'qs'
import { QueryClient, QueryClientProvider } from 'react-query'

import { PrivacyPolicy } from '@h2/features/privacyPolicy'

import InitialSetup from './components/onboarding/InitialSetup'
import UpTheLadder from './components/features/UpTheLadder'
import About from './components/features/About'
import LocalOpportunities from './components/features/LocalOpportunities'
import YourPlan from './components/features/YourPlan'
import RequestDemoAccess from './components/features/RequestDemo'
import QuotePage from './components/features/Quote'
import PricingGrid from './components/features/PricingGrid'
import LatestWebinar from './components/webinar/LatestWebinar'
import LandingContent from './components/upgrade/LandingContent'
import FeatureWrap from './components/features/FeatureWrap'
import { WebinarResponseForm } from './components/webinar/WebinarResponseForm'
import HomePage from './components/HomePage'
import QuoteConfirmation from './components/features/QuoteConfirmation'
import { ChooseStateRedirector } from './components/features/ChooseStateRedirector'

export default class Routes extends React.Component {
  constructor() {
    super()
    browserHistory.listen(location => {
      window.ga('set', 'page', location.pathname + location.search)
      window.ga('send', 'pageview')
    })
  }

  queryClient = new QueryClient()

  render() {
    /*
     * const store = this.props.store;
     * const dispatch = store.dispatch;
     */

    return (
      <Router history={browserHistory}>
        <QueryClientProvider client={this.queryClient}>
          <Switch>
            <Route path="/" exact>
              <FeatureWrap>
                <HomePage />
              </FeatureWrap>
            </Route>
            <Route path="/onboarding/setup">
              <FeatureWrap>
                <InitialSetup />
              </FeatureWrap>
            </Route>
            <Route path="/:state?">
              <FeatureWrap>
                <Switch>
                  <Route path="/:state?/uptheladder" component={UpTheLadder} />
                  <Route path="/:state?/plan" component={YourPlan} />
                  <Route
                    path="/:state?/localopportunities"
                    component={LocalOpportunities}
                  />
                  <Route path="/:state?/about" component={About} />
                  <Route path="/:state?/privacy" component={PrivacyPolicy} />
                  <Route path="/:state?/:campaignId?/quote" component={QuotePage} />
                  <Route
                    path="/:state?/:campaignId?/quote/confirmation"
                    component={QuoteConfirmation}
                  />
                  <Route path="/:state?/pricing/:pageId?" component={PricingGrid} />
                  <Route
                    path="/:state?/:campaignId?/webinar/latest/:arrayIndex?"
                    component={LatestWebinar}
                  />
                  <Route
                    path="/:state?/:campaignId?/webinar/:response?"
                    component={WebinarResponseForm}
                  />
                  <Route path="/:state?/demo-access" component={RequestDemoAccess} />
                  <Route
                    path="/:state?/demo-access/confirmation"
                    component={QuoteConfirmation}
                  />

                  <Route path="/:state" exact component={LandingContent} />
                  <Route path={'/:state?/l/*'}>
                    <ChooseStateRedirector />
                  </Route>
                </Switch>
              </FeatureWrap>
            </Route>
          </Switch>
        </QueryClientProvider>
      </Router>

      /*
       *undefined
       *undefined
       *undefined
       */
    )
  }
}

export const browserHistory = qhistory(createBrowserHistory(), qs.stringify, qs.parse)
